module.exports = __webpack_public_path__ + "img/ruby_96.a78dcf48.png";